import { Component, computed, input, output } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { QuickActionProps } from '@unity/utils/types';
import { ActionSharedComponent } from '../action-shared/action-shared.component';

@Component({
  selector: 'unity-action-download-shared',
  standalone: true,
  imports: [KENDO_BUTTON, ActionSharedComponent],
  templateUrl: './action-download-shared.component.html',
  styleUrl: './action-download-shared.component.scss',
})
export class ActionDownloadSharedComponent {
  protected readonly $action = computed<QuickActionProps>(() => {
    const buttonText = this.$buttonText();
    return {
      actionName: buttonText,
      description: buttonText,
      icon: 'downloadIcon',
    };
  });
  public readonly $disabled = input.required<boolean>({ alias: 'disabled' });
  public readonly $buttonText = input.required<string>({ alias: 'buttonText' });

  public readonly downloadEvent = output();

  protected onClickDownload() {
    this.downloadEvent.emit();
  }
}
